import { withForm } from "@eisox/form";

import { holdAbove, holdBelow, setpointFormOptions, widenBoundsTo, type BoundFieldName } from "../helpers";

/**
 * A bound slider, held one step short of the other side of its pair: the API takes any order, so
 * the form is the only place a min above its max is kept out.
 *
 * Its range opens on the bound the automate reports rather than on the value being dragged: a
 * bound outside the hard-coded range stays reachable, and the track keeps its scale under the thumb.
 */
const SetpointBoundField = withForm({
  ...setpointFormOptions,
  props: {} as {
    name: BoundFieldName;
    other: BoundFieldName;
    side: "min" | "max";
    label: React.ReactNode;
    range: { min: number; max: number };
    step: number;
  },
  render: function Render({ form, name, other, side, label, range, step }) {
    const bounds = widenBoundsTo(range, form.options.defaultValues?.[name]);

    return (
      <form.AppField name={name}>
        {field => (
          <field.Slider
            classNames={{ control: "w-full", value: "w-16 justify-end" }}
            label={label}
            min={bounds.min}
            max={bounds.max}
            step={step}
            onValueChange={value => {
              const otherValue = form.getFieldValue(other);
              const held = side === "min" ? holdBelow(value, otherValue, step) : holdAbove(value, otherValue, step);
              if (held !== undefined && held !== value) field.handleChange(held);
            }}
          />
        )}
      </form.AppField>
    );
  },
});

export { SetpointBoundField };
